/* eslint-disable no-case-declarations */
import { fromJS } from 'immutable';
import * as types from '../constants';
// import { designSettingsDefault } from './state/design';

const getEndTime = () => {
  let date = new Date();
  // eslint-disable-next-line no-restricted-globals
  date = date.setDate(date.getDate() + 2);
  return new Date(date).toISOString();
};

const getIndexField = (state, field, id) => {
  const index = state.getIn(['upsellCampaign', field]).findIndex(item => item === id);
  if (index >= 0) return index;
  return state.getIn(['upsellCampaign', field]).findIndex(item => item?.get?.('id') === id);
};

const upsellDefault = {
  id: 0,
  upsellType: 'bundle', // 'popup', 'bundle'
  campaignName: '',
  // target
  targetType: 'products', //  'products, 'collection'
  targetProductIds: [],
  targetProductDetail: [],
  // recommend
  recommendType: 'products', //  'products, 'collection'

  // discount
  discountType: 'no',
  discountValue: '0',

  offerMessage: `Hurry up! Add an indispensable choice with {{product_name}}`, // hiện thị khi không setupdiscount
  motivationalMessage: 'Hurry up! Add an indispensable choice with {{product_name}}',

  showOnDesktop: true,
  showOnMobile: true,

  startDate: new Date().toISOString(),
  activeEndDate: false,
  endDate: getEndTime()
};

const dataState = fromJS({
  upsellCampaign: upsellDefault,
  listCampaign: [],

  getListCampaignLoading: true,

  getListTargetProductsLoading: false,
  saveSettingLoading: false,
  saveSettingResult: 0,
  changeStatusLoading: false,
  changeStatusResult: 0,
  deleteCampaignLoading: false,
  deleteCampaignResult: 0
});

let data = '';
let targetIds = [];
let indexRemove = 0;
let indexRemoveDetail = 0;

const upsellBundleReducer = (state = dataState, action) => {
  switch (action.type) {
    case types.GET_LIST_UPSELL_BUNDLE:
      return state.set('getListCampaignLoading', true);
    case types.GET_LIST_UPSELL_BUNDLE_RESULT:
      return state.set('getListCampaignLoading', false).set('listCampaign', fromJS(action.res));
    case types.CHANGE_UPSELL_BUNDLE_SETTING_FIELD:
      return state.setIn(['upsellCampaign', action.payload.field], action.payload.value);
    case types.CHANGE_UPSELL_BUNDLE_PRODUCT_DETAIL_FIELD:
      return state.setIn(['upsellCampaign', action.payload.field], action.payload.value);
    case types.CHANGE_UPSELL_BUNDLE_FIELD:
      return state.set(action.payload.field, action.payload.value);

    // TARGET
    case types.CHANGE_TARGET_PRODUCT_UPSELL_BUNDLE:
      return state
        .set('getListTargetProductsLoading', true)
        .setIn(['upsellCampaign', 'targetProductIds'], fromJS(action.ids));
    case types.CHANGE_TARGET_PRODUCT_UPSELL_BUNDLE_RESULT:
      return state
        .set('getListTargetProductsLoading', false)
        .setIn(['upsellCampaign', 'targetProductDetail'], fromJS(action.res));
    case types.REMOVE_TARGET_PRODUCT_UPSELL_BUNDLE:
      indexRemove = getIndexField(state, 'targetProductIds', action.id);
      indexRemoveDetail = getIndexField(state, 'targetProductDetail', action.id);
      return state
        .removeIn(['upsellCampaign', 'targetProductIds', indexRemove])
        .removeIn(['upsellCampaign', 'targetProductDetail', indexRemoveDetail]);

    // CHANGE STATUS
    case types.CHANGE_STATUS_UPSELL_BUNDLE:
      return state.set('changeStatusLoading', true);
    case types.CHANGE_STATUS_UPSELL_BUNDLE_RESULT:
      if (action.res) {
        return state
          .setIn(['listCampaign', action.payload.index, 'status'], action.payload.status)
          .set('changeStatusLoading', false);
      }
      return state.set('changeStatusLoading', false);

    // DELETE CAMPAIGN
    case types.DELETE_CAMPAIGN_UPSELL_BUNDLE:
      return state.set('deleteCampaignLoading', true);
    case types.DELETE_CAMPAIGN_UPSELL_BUNDLE_RESULT:
      return state.set('deleteCampaignLoading', false).set('deleteCampaignResult', action.res);

    // SAVE SETTING
    case types.SAVE_SETTING_UPSELL_BUNDLE_CAMPAIGN:
      return state.set('saveSettingLoading', true);
    case types.SAVE_SETTING_UPSELL_BUNDLE_CAMPAIGN_RESULT:
      if (action.res) {
        return state
          .setIn(['upsellCampaign', 'id'], action.res)
          .set('saveSettingResult', 1)
          .set('saveSettingLoading', false);
      }
      return state.set('saveSettingLoading', false).set('saveSettingLoading', 2);

    // GET DETAIL
    case types.GET_DETAIL_CAMPAIGN_UPSELL_BUNDLE:
      if (action.id === 'new') {
        return state.set('upsellCampaign', fromJS(upsellDefault)).set('getDetailUpsellLoading', false);
      }
      return state.set('getDetailUpsellLoading', true);
    case types.GET_DETAIL_CAMPAIGN_UPSELL_BUNDLE_RESULT:
      if (action.payload.status) {
        data = action.payload.data;

        targetIds = JSON.parse(data.target_ids) || [];
        return (
          state
            .setIn(['upsellCampaign', 'id'], data.id)
            .setIn(['upsellCampaign', 'upsellType'], data.upsell_type)
            .setIn(['upsellCampaign', 'showProductPage'], data.show_product_page)
            .setIn(['upsellCampaign', 'showCartPage'], data.show_cart_page)
            .setIn(['upsellCampaign', 'campaignName'], data.campaign_name)
            // target
            .setIn(['upsellCampaign', 'targetProductIds'], fromJS(targetIds))
            // discount
            .setIn(['upsellCampaign', 'discountType'], data.discount_type)
            .setIn(['upsellCampaign', 'discountValue'], data.discount_value)

            // message
            .setIn(['upsellCampaign', 'offerMessage'], data.bundle_message)
            .setIn(['upsellCampaign', 'motivationalMessage'], data.bundle_message)

            .setIn(['upsellCampaign', 'showOnDesktop'], data.show_on_desktop)
            .setIn(['upsellCampaign', 'showOnMobile'], data.show_on_mobile)
            .setIn(['upsellCampaign', 'startDate'], data.start_date)
            .setIn(['upsellCampaign', 'endDate'], data.end_date)
            .setIn(['upsellCampaign', 'activeEndDate'], data.active_end_date)
            .set('getDetailUpsellLoading', false)
        );
      }
      return state.set('getDetailUpsellLoading', false);
    default:
      return state;
  }
};
export default upsellBundleReducer;
